import Vue from 'vue'
import Toasted from 'vue-toasted'

Vue.use(Toasted, {"position":"top-right","duration":4000,"keepOnHover":true,"iconPack":"mdi","action":{"icon":"mdi-close","onClick":(e, toastObject) => {
        toastObject.goAway(0);
      }}})

const globals = undefined
if(globals) {
  globals.forEach(global => {
    Vue.toasted.register(global.name, global.message, global.options)
  })
}

export default function (ctx, inject) {
  inject('toast', Vue.toasted)
}
